import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { ILatestUpdatedPages } from "InterfacesTypes/interfaces";

export interface ILatestUpdatedPagesState {
  recentlyUpdatedPages: ILatestUpdatedPages[];
  loading: boolean;
  error: string | null;
}

const initialState: ILatestUpdatedPagesState = {
  recentlyUpdatedPages: [],
  loading: false,
  error: null,
};

export const fetchRecentlyUpdatedPages = createAction(
  "recentlyUpdatedPages/fetchRecentlyUpdatedPages"
);

export const recentlyUpdatedPagesSlice = createSlice({
  name: "recentlyUpdatedPages",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<ILatestUpdatedPages[]>) {
      state.loading = false;
      state.recentlyUpdatedPages = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setRecentlyUpdatedPages(
      state,
      action: PayloadAction<ILatestUpdatedPages[]>
    ) {
      state.recentlyUpdatedPages = action.payload;
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  setRecentlyUpdatedPages,
} = recentlyUpdatedPagesSlice.actions;

export const recentlyUpdatedPagesReducer = recentlyUpdatedPagesSlice.reducer;
